import React, { useRef, useEffect, useState } from 'react';
import { useGlobalContext } from '../../js/context';
import anime from 'animejs/lib/anime.es.js';
import './Tooltip.scss'
import TooltipIcon from '../../assets/images/glossy-tooltip.png'

const Tooltip = ({ children, direction, className, iconType }) => {
  const { isMobile } = useGlobalContext();
  const tooltipRef = useRef();
  const [active, setActive] = useState(false);

  const tooltipHandler = () => {
    setActive(() => !active);

    if (!isMobile) {
      anime({
        targets: tooltipRef.current,
        opacity: [0, 1],
        easing: 'easeOutExpo',
      });
    }
  };

  const changeHandler = (e) => {
    if (!tooltipRef.current.contains(e.target)) {
      setActive(false);
    }
  };

  const closeTooltipHandler = () => {
    setActive(false);
  };

  useEffect(() => {
    if (!active) {
      return;
    }
    document.addEventListener('click', changeHandler);
    return () => document.removeEventListener('click', changeHandler);
  }, [active]);

  return (
    <div
      className={`${className} tos-tooltip ${
        active ? 'tos-tooltip--active' : ''
      }`}
      ref={tooltipRef}
    >
      <button
        className={`tos-tooltip__icon ${
          active ? 'tos-tooltip__icon--active' : ''
        }`}
        onClick={tooltipHandler}
      >
        {iconType === 'svg' && (
          <svg
            width='8'
            height='14'
            viewBox='0 0 8 14'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M2.33218 4.13971C1.98655 4.75057 1.22193 4.95924 0.624303 4.60595C0.0267285 4.25258 -0.177483 3.47092 0.168204 2.86007C0.814704 1.71762 2.02618 0.944336 3.4158 0.944336C5.4868 0.944336 7.1658 2.66058 7.1658 4.77767C7.16568 6.18029 6.32405 7.32556 5.2908 7.97211C4.4608 8.49153 4.9783 9.88878 3.41243 9.88878C2.72218 9.88878 2.16243 9.31672 2.16243 8.611C2.16243 8.56615 2.16468 8.52181 2.16918 8.47811C2.2038 7.80242 2.49855 7.25247 2.81955 6.85265C3.15855 6.43048 3.60418 6.08573 3.94493 5.8786C5.8408 4.72656 3.52843 2.36957 2.33218 4.13971ZM3.41243 11.1666C2.72218 11.1666 2.16243 11.7386 2.16243 12.4443C2.16243 13.1501 2.72218 13.7221 3.41243 13.7221C4.1028 13.7221 4.66243 13.1501 4.66243 12.4443C4.66243 11.7386 4.1028 11.1666 3.41243 11.1666Z'
              fill='white'
            />
          </svg>
        )}
       {iconType === 'image' && <img src={TooltipIcon} alt='icon' />}
      </button>

      {/* Wrapping */}
      {active && (
        <div
          className={`tos-tooltip__content tos-tooltip__content--${
            direction || 'top'
          }`}
        >
          <button
            className='tos-tooltip__close-btn'
            onClick={closeTooltipHandler}
          >
            &times;
          </button>
          {children}
        </div>
      )}
    </div>
  );
};

export default Tooltip;
